import { Sparkles } from "lucide-react";
export function Loading({ label = "Preparing your workspace…" }: { label?: string }) {
  return <div className="grid min-h-[60vh] place-items-center"><div className="text-center"><Sparkles className="mx-auto mb-3 animate-pulse text-brand" /><p className="text-sm text-muted">{label}</p></div></div>;
}
